import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { FirebaseCrashlytics } from '@capacitor-community/firebase-crashlytics';

@Injectable({
  providedIn: 'root'
})
export class TranslateConfigService {

  public translateText: string;
  public languageDefault = 'es';
  private supportLanguages = ['es'];
  constructor(private translate: TranslateService) { }

  initTranslate() {
    const language = this.translate.getBrowserLang();
    // console.log('IDIOMA -> '+language);
    // Set the default language for translation strings, and the current language.
    this.translate.setDefaultLang(this.languageDefault);
    this.languageDefault = this.supportLanguages.includes(language) ? language : this.languageDefault;
    this.translateLanguage();
  }

  translateLanguage(): void {
    // console.log('SE USA EL IDIOMA -> '+this.languageDefault);
    this.translate.use(this.languageDefault);
  }

  async getCurrentLanguage(): Promise<string>{
    try{
      const language = this.translate.getBrowserLang();
      return this.supportLanguages.includes(language) ? language : this.languageDefault;
    }catch (err){
      const message = JSON.stringify(err);
      await FirebaseCrashlytics.recordException({message: message});
      return this.languageDefault;
    }
  }

  getTranslate(id: string) {
    try {
        this.translate.get(id).subscribe( (text: string) => {
          if (text === id) {
            this.translateText = '';
          } else {
            this.translateText = text;
          }
      });
    } catch (error) {
      this.translateText = '';
    }
    return this.translateText;
  }
}
